<!-- 企业级-业务领域-会议室预约 -->
<template>
  <div class="mainArea CConference">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-tabs v-model="tabActive" @tab-click="tabChange" class="tabList" stretch>
          <el-tab-pane label="预约配置" name="1">
            <cconferenceconfig v-if="tabActive=='1'"></cconferenceconfig>
          </el-tab-pane>
          <el-tab-pane label="预约记录" name="2">
            <cconferencelog v-if="tabActive=='2'"></cconferencelog>
          </el-tab-pane>
        </el-tabs>
      </div>
      
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import cconferenceconfig from "../CConference/CConferenceConfig"
  import cconferencelog from "../CConference/CConferenceLog"

  export default {
    name: 'CConference',
    components: {
      CBreadCrumb,
      cconferenceconfig,
      cconferencelog,
    },
    data() {
      return {
        tabActive:'1',
      };
    },
    mounted(){

    },
    created: async function () {
      
    },
    methods: {
      tabChange(tab, event){
        if(tab.index == 1){
          
        }else{
          
        }
      },
      
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CConference{
  .tabList{
    width: 100%;
    // tabs标签
    .el-tabs__header {
      width: 100%;
      margin-bottom: 0;
      box-sizing: border-box;
      border-bottom: 1px solid #E4E7ED;
      .el-tabs__nav-wrap {
        padding-left: 20px;
        width: 360px;
      }
      .el-tabs__item {
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CAuthorizationManage/CConference.vue